<template>
  <div class="verification">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>核销方管理</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="search">
      <span>核销方名称：</span>
      <el-input v-model="list.verificationName" placeholder="请输入核销方名称"></el-input>
      <span>核销方票付通账号：</span>
      <el-input v-model="list.account" placeholder="请输入核销方票付通账号"></el-input>
      <el-button type="primary" @click="getCategroy()">查找</el-button>
      <el-button type="primary" @click="onAdd">添加</el-button>
    </div>
    <el-table :data="tableData" style="width: 100%" border>
      <el-table-column align="center" prop="verificationId" label="核销方Id" width="width"></el-table-column>
      <el-table-column align="center" prop="verificationName" label="核销方名称" width="width"></el-table-column>
      <el-table-column align="center" prop="account" label="票付通账号" width="width"></el-table-column>
      <el-table-column align="center" prop="password" label="票付通密码" width="width"></el-table-column>
      <el-table-column align="center" prop="addTime" label="时间" width="width"></el-table-column>
      <el-table-column align="center" label="操作" width="width">
        <template slot-scope="{ row }">
          <el-button type="primary" size="mini" @click="onEdit(row)">编辑</el-button>
          <el-button type="primary" size="mini" @click="onDelRow(row.verificationId)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="list.currentPage"
      :page-sizes="[5, 10, 15, 20]"
      :page-size="list.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="pagination.total"
    ></el-pagination>
    <!-- 添加一级核销方 -->
    <el-dialog
      destroy-on-close
      :title="addOrEdit.verificationId === 0 ? '添加核销方' : '编辑核销方'"
      :visible.sync="addDialogVisible"
      width="30%"
      @close="onDiaLog"
    >
      <el-form ref="form" label-width="100px">
        <el-form-item label="核销方名称">
          <el-input placeholder="请输入要核销方名称" v-model="addOrEdit.verificationName"></el-input>
        </el-form-item>
      </el-form>
      <el-form ref="form" label-width="100px">
        <el-form-item label="票付通账号">
          <el-input placeholder="请输入核销方票付通账号" v-model="addOrEdit.account"></el-input>
        </el-form-item>
      </el-form>
      <el-form ref="form" label-width="100px">
        <el-form-item label="票付通密码">
          <el-input placeholder="请输入核销方票付通密码" v-model="addOrEdit.password" ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="onEditCateOk">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  verification,
  addVerification,
  delVerification
} from "../../api/WriteOffManagement";
export default {
  name: "verification",
  data() {
    return {
      addDialogVisible: false,
      tableData: [],
      list: {
        pageSize: 5,
        currentPage: 1,
        verificationName: "",
        account:'',
      },
      pagination: {},
      addOrEdit: {
        verificationId: 0,
        verificationName: null,
        account:'',
        password:''
      }
    };
  },
  created() {
    this.getCategroy();
  },
  methods: {
    //删除
    onDelRow(verificationId) {
      this.$confirm("是否删除这条数据", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          const { data } = await delVerification({
            verificationId
          });
          if (data.code === 0) {
            this.$message({
              message: data.msg,
              type: "success"
            });
            this.getCategroy();
          } else {
            this.$message({
              message: data.msg,
              type: "error"
            });
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    onEdit(row) {
      this.addOrEdit.verificationId = row.verificationId;
      this.addOrEdit.verificationName = row.verificationName;
      this.addOrEdit.account = row.account;
      this.addOrEdit.password = row.password;
      this.addDialogVisible = true;
    },
    onDiaLog() {
      this.addOrEdit.verificationId = null;
      this.addOrEdit.account = '';
      this.addOrEdit.password = '';
      this.addOrEdit.verificationName = null;
    },
    onAdd() {
      this.addDialogVisible = true;
      this.addOrEdit.verificationId = 0;
    },
    async getCategroy() {
      const { data } = await verification(this.list);
      if (data.code === 0) {
        this.tableData = data.list;
        this.pagination = data.pagination;
      } else {
        this.$message.error(data.msg);
      }
    },
    //添加一级核销方
    async onEditCateOk() {
      if (!this.addOrEdit.verificationName || !this.addOrEdit.account || !this.addOrEdit.password) {
        return this.$message({
          message: "请把数据填写完整！",
          type: "warning"
        });
      }
      const { data } = await addVerification(this.addOrEdit);
      if (data.code == 0) {
        this.$message({
          message: data.msg,
          type: "success"
        });
        this.getCategroy();
      } else {
        this.$message({
          message: data.msg,
          type: "error"
        });
      }
      this.addDialogVisible = false;
      this.addOrEdit.verificationId = null;
      this.addOrEdit.verificationName = null;
    },
    sendAvatar() {
      this.$refs.fileRef.click();
    },
    handleSizeChange(num) {
      this.list.pageSize = num;
      this.getCategroy();
    },
    handleCurrentChange(num) {
      this.list.currentPage = num;
      this.getCategroy();
    }
  }
};
</script>
<style lang="less" scoped>
.verification {
  .el-breadcrumb {
    height: 35px;
    border-bottom: 1px solid rgb(192, 191, 191);
  }
  .search {
    margin-top: 50px;
    .el-select {
      margin: 0 20px;
    }
    .select {
      margin: 0 10px;
    }
    .el-input {
      width: 200px;
      margin: 0 20px;
    }
  }
  .el-table {
    margin-top: 50px;
  }
  .el-pagination {
    float: right;
    margin-top: 50px;
  }
  /deep/.el-form {
    .el-form-item {
      .el-form-item__content {
        .elbtn {
          margin-left: 10px;
          background-color: unset;
          width: 110px;
          height: 110px;
          text-align: center;
          line-height: 110px;
          color: #000;
          border: 1px solid #ccc;
        }
        display: flex;
        .img {
          position: relative;
          margin: 0 20px;
          height: 100px;
          width: 100px;
          img {
            height: 100px;
            width: 100px;
            border: 1px solid #c0ccda;
          }
          div {
            position: absolute;
            top: 0;
            right: 5px;
            height: 10px;
            width: 10px;
            z-index: 100;
          }
        }
        .addImg {
          display: inline-block;
          width: 100px;
          height: 100px;
          border: 1px dashed #c0ccda;
          text-align: center;
          line-height: 100px;
          cursor: pointer;
          i {
            width: 50px;
            height: 50px;
            font-size: 20px;
            color: #c0ccda;
          }
        }
        span {
          margin-left: 30px;
          color: red;
        }
      }
    }
  }
}
</style>